import React from "react";
import { useContext } from "react";
import { LeadData } from "./VayuLead";
import { getFormattedDate } from "modules/utilities/utility";
import SoftBadge from "modules/common/SoftBadge";
import NoData from "assets/svgs/no_data/NoData";

function VayuLeadActivityLog() {
  const { doc } = useContext(LeadData);

  const formatDate = (inputDate) => {
    return <SoftBadge variant="info">{getFormattedDate(inputDate)}</SoftBadge>;
  };

  const renderCaseTitle = (title) => {
    return <div>{title}</div>;
  };

  const warningText = (name) => {
    return <span className="text-warning mx-1 fw-bold">{name}</span>;
  };

  const successText = (orderDisplayId) => {
    return <span className="text-success mx-1 fw-bold">{orderDisplayId}</span>;
  };
  const infoText = (info) => {
    return <span className="text-info mx-1 fw-bold">{info}</span>;
  };
  const secondaryText = (info) => {
    return <span className="text-secondary mx-1 fw-bold">{info}</span>;
  };

  function formatEventId(eventId) {
    const words = eventId.split("_");
    const formattedWords = words.map((word) => {
      const capitalizedWord =
        word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
      return capitalizedWord;
    });
    const formattedEventId = formattedWords.join(" ");
    return formattedEventId;
  }

  const activityRow = "d-flex justify-content-between w-100 align-items-center";
  const renderActivityLog = (activityLog) => {
    switch (activityLog?.event_id) {
      case "VAYU_USER_RESEARCH":
        return (
          <div className={`${activityRow} border p-2 rounded-2`}>
            <div>
              <span className="text-warning mx-1 fw-bold">
                {activityLog.author_name}
              </span>
              <span className="text-info mx-1 fw-bold">{formatEventId(activityLog?.event_id)}</span>
            </div>
            {formatDate(activityLog?.meta?.representative?.updated_at)}
          </div>
        );
    }
  };

  return (
    <>
      {doc?.activity_logs?.length? doc?.activity_logs?.map((item) => {
        return renderActivityLog(item);
      }):<div className="border p-2 rounded-2 text-center">Data is not Available <NoData /></div>}
    </>
  );
}

export default VayuLeadActivityLog;
